export default __webpack_public_path__ + "static/media/Social Links.c9583d9b.svg";